import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

const ActivityCheckbox = ({ handleCheck, loading }) => (
  <div className="activity-checkbox">
    <Input type="checkbox" onChange={handleCheck} disabled={loading} />
  </div>
);

ActivityCheckbox.propTypes = {
  handleCheck: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ActivityCheckbox;
